module.exports = __webpack_public_path__ + "img/save.33bf6355.svg";